import { IRatePhotoParams } from "services/api/charactersApi";

enum LikeStatusEnum {
  Like = 'like',
  Dislike = 'dislike',
}

export interface IRateGeneratedPhotoFormValues {
  type?: string | null;
  comment?: string;
};

interface IPhotoGeneratorFormValues extends IRateGeneratedPhotoFormValues {
  pose: string;
  position: string;
  clothingLevel: string;
  background: string;
}


const poseOptionDomainValues = {
  standing: "standing",
  sitting: "sitting",
  laying: "laying"
};

const positionOptionDomainValues = {
  facingForward: "facing_forward",
  facingBackward: "facing_backward"
};

const clothingLevelOptionDomainValues = {
  fullyClothed: "fully_clothed",
  underwear: "underwear",
  undressed: "undressed"
};

const backgroundOptionDomainValues = {
  parkStreet: "park_street",
  kitchen: "kitchen",
  bedroom: "bedroom",
  office: "office"
};

const poseOptions = [
  { label: "Standing", value: poseOptionDomainValues.standing },
  { label: "Sitting", value: poseOptionDomainValues.sitting },
  { label: "Laying", value: poseOptionDomainValues.laying }
];

const positionOptions = [
  { label: "Facing forward", value: positionOptionDomainValues.facingForward },
  { label: "Facing backward", value: positionOptionDomainValues.facingBackward }
];

const clothingLevelOptions = [
  { label: "Fully clothed", value: clothingLevelOptionDomainValues.fullyClothed },
  { label: "Underwear", value: clothingLevelOptionDomainValues.underwear },
  { label: "Undressed", value: clothingLevelOptionDomainValues.undressed }
];

const backgroundOptions = [
  { label: "Park/Street", value: backgroundOptionDomainValues.parkStreet },
  { label: "Kitchen", value: backgroundOptionDomainValues.kitchen },
  { label: "Bedroom", value: backgroundOptionDomainValues.bedroom },
  { label: "Office", value: backgroundOptionDomainValues.office }
];

const initialValues: IPhotoGeneratorFormValues = {
  pose: poseOptionDomainValues.standing,
  position: positionOptionDomainValues.facingForward,
  clothingLevel: clothingLevelOptionDomainValues.fullyClothed,
  background: backgroundOptionDomainValues.parkStreet,
  type: null,
  comment: ""
};

const attributesToGeneratePhoto = (values: IPhotoGeneratorFormValues): IPhotoGeneratorFormValues => {
  return {
    pose: values.pose,
    position: values.position,
    clothingLevel: values.clothingLevel,
    background: values.background,
  };
};

const attributesToRateGeneratedPhoto = (values: IRateGeneratedPhotoFormValues): IRatePhotoParams => {
  return {
    type: values.type || null,
    comment: values.comment
  };
};

export {
  initialValues,
  attributesToGeneratePhoto,
  attributesToRateGeneratedPhoto,
  IPhotoGeneratorFormValues,
  poseOptions,
  positionOptions,
  clothingLevelOptions,
  backgroundOptions,
  poseOptionDomainValues,
  positionOptionDomainValues,
  clothingLevelOptionDomainValues,
  backgroundOptionDomainValues,
  LikeStatusEnum
};
